module.exports = __webpack_public_path__ + "static/img/3g.45b0311.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/3g.jpg
// module id = RKkl
// module chunks = 0